import "./RaikoBigBanner.scss"
import {RaikoBaseCardContainer} from "@moeindal/base-raiko-panel-components";

import photo1 from "./img/poster_1.png"
import photo2 from "./img/poster_2.png"
import photo3 from "./img/poster_3.png"
import photo4 from "./img/poster_4.png"
import photo5 from "./img/poster_5.png"
import photo6 from "./img/poster_6.png"
import photo7 from "./img/poster_7.png"
import photo8 from "./img/poster_8.png"
import photo9 from "./img/poster_9.png"
import photo10 from "./img/poster_10.png"
import {useEffect, useState} from "react";

export default function RaikoBigBanner() {

    const images = [
        photo1,
        photo2,
        photo3,
        photo4,
        photo5,
        photo6,
        photo7,
        photo8,
        photo9,
        photo10,
    ]

    const [selectedImage, setSelectedImage] = useState(photo1)

    useEffect(() => {
        const randomNumber = Math.floor(Math.random() * 10);
        setSelectedImage(images[randomNumber])
    }, []);

    return <RaikoBaseCardContainer className={"baseRaikoBigBannerContainer"}>
        <img src={selectedImage} alt=""/>
    </RaikoBaseCardContainer>
}